<template>
	<v-card id="filters">
		<v-card-title class="pa-0">
			<v-btn
				color="warning lighten-2 color--text"
				class="text-none"
				@click="raz()"
				:disabled="!filters.search &&
									!filters.ref_mat &&
									!filters.t_aux &&
									!filters.has_rv &&
									!filters.asset_type_clean &&
									!filters.babel_id &&
									!filters.origin &&
									!filters.behive_category &&
									!filters.ingest_date_after &&
									!filters.ingest_date_before &&
									!filters.has_proxy">
				<v-icon class="mr-2">clear_all</v-icon>
				Réinitialiser
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				color="success lighten-2 color--text"
				class="text-none"
				:loading="loading"
				@click="search()">
				<v-icon class="mr-2">search</v-icon>
				Rechercher
				<span class="btn-label ml-3">
					Ctrl + Entrée
				</span>
			</v-btn>
			<v-btn flat icon @click="$emit('close')">
				<v-icon>close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text id="card-text">
			<table>
				<tbody>
					<tr>
						<th>
							Programme
						</th>
						<td>
							<BabelIdField
								:rules="[]"
								:solo="true"
								:dense="true"
								:param="null"
								:readonly="false"
								:hide_details="true"
								:clearable="true"
								ref="babel-id-input"
								:value="filters.babel_id"
								@change="filters.babel_id = $event">
							</BabelIdField>
						</td>
					</tr>
					<tr>
						<th>Ayant-droit</th>
						<td>
							<OwnerField
								:rules="[]"
								:solo="true"
								:dense="true"
								:param="null"
								:readonly="false"
								:hide_details="true"
								:clearable="true"
								ref="taux-input"
								:value="filters.t_aux"
								@change="filters.t_aux = $event">
							</OwnerField>
						</td>
					</tr>
					<tr>
						<th>Type d'asset</th>
						<td>
							<v-autocomplete
								clearable
								solo
								class="dense_input"
								dense
								browser-autocomplete="off"
								:menu-props="{contentClass: 'select-background-base'}"
								hide-details
								ref="assettype-input"
								item-text="text"
								item-value="text"
								:items="asset_types"
								v-model="filters.asset_type_clean">
								<template v-slot:selection="{ item }">
									<v-icon :class="item.color" class="mr-1">
										{{ item.icon }}
									</v-icon>
									<span :class="item.color">{{ item.text }}</span>
								</template>
								<template v-slot:item="{ item }">
									<v-list-tile-avatar>
										<v-icon :class="item.color">{{ item.icon }}</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title :class="item.color">
											{{ item.text }}
										</v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-autocomplete>
						</td>
					</tr>
					<tr>
						<th>
							Référence
						</th>
						<td>
							<v-text-field
								solo
								class="dense_input"
								clearable
								placeholder="xx/xx/xxxx | suifa-xxx | maestro-xxx"
								browser-autocomplete="off"
								hide-details
								ref="ref-mat-input"
								v-model="filters.ref_mat"
								@click:clear="filters.ref_mat = null">
							</v-text-field>
						</td>
					</tr>
					<tr>
						<th>Enregistré après</th>
						<td>
							<v-menu
								ref="ingest_date_after"
								v-model="ingest_date_after_menu"
								:nudge-right="40"
								lazy
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px">
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="filters.ingest_date_after"
										readonly
										solo
										class="dense_input"
										hide-details
										clearable
										@click:clear="filters.ingest_date_after = null"
										v-on="on">
									</v-text-field>
								</template>
								<v-date-picker
									v-model="filters.ingest_date_after"
									color="primary color--text"
									class="background"
									locale="fr-fr"
									@input="ingest_date_after_menu = false"
									:first-day-of-week="1"
									no-title scrollable>
								</v-date-picker>
							</v-menu>
						</td>
					</tr>
					<tr>
						<th>Enregistré avant</th>
						<td>
							<v-menu
								ref="ingest_date_before"
								v-model="ingest_date_before_menu"
								:nudge-right="40"
								lazy
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px">
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="filters.ingest_date_before"
										readonly
										solo
										class="dense_input"
										hide-details
										clearable
										@click:clear="filters.ingest_date_before = null"
										v-on="on">
									</v-text-field>
								</template>
								<v-date-picker
									v-model="filters.ingest_date_before"
									color="primary color--text"
									class="background"
									locale="fr-fr"
									@input="ingest_date_before_menu = false"
									:first-day-of-week="1"
									no-title scrollable>
								</v-date-picker>
							</v-menu>
						</td>
					</tr>
					<tr>
						<th>Recherche</th>
						<td>
							<v-text-field
								solo
								class="dense_input"
								clearable
								placeholder="Rechercher par mots-clés"
								browser-autocomplete="off"
								hide-details
								ref="search-input"
								v-model="filters.search"
								@click:clear="filters.search = null">
							</v-text-field>
						</td>
					</tr>
					<tr>
						<th>Catégorie Behive</th>
						<td>
							<v-autocomplete
								clearable
								solo
								class="dense_input"
								dense
								browser-autocomplete="off"
								:menu-props="{contentClass: 'select-background-base'}"
								hide-details
								ref="behive-cat-input"
								item-text="text"
								item-value="text"
								:items="behive_categories"
								v-model="filters.behive_category">
								<template v-slot:selection="{ item }">
									<v-icon :class="item.color" class="mr-1">
										{{ item.icon }}
									</v-icon>
									<span :class="item.color">
										{{ item.text | spacedTitleCase }}
									</span>
								</template>
								<template v-slot:item="{ item }">
									<v-list-tile-avatar>
										<v-icon :class="item.color">{{ item.icon }}</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title :class="item.color">
											{{ item.text | spacedTitleCase }}
										</v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-autocomplete>
						</td>
					</tr>
					<tr>
						<th>Origine</th>
						<td>
							<v-btn-toggle
								v-model="filters.origin"
								mandatory
								class="background darken-1 ma-1 darken-input">
								<v-btn
									:flat="filters.origin !== 0"
									:class="{ 'color--text': filters.origin === 0 }"
									small
									color="primary"
									class="text-none px-3"
									:value="0">
									Tous
								</v-btn>
								<v-btn
									:flat="filters.origin !== 1"
									:class="{ 'color--text': filters.origin === 1 }"
									small
									color="amber lighten-1"
									class="text-none px-3"
									:value="1">
									Suifa
								</v-btn>
								<v-btn
									:flat="filters.origin !== 2"
									:class="{ 'color--text': filters.origin === 2 }"
									small
									color="blue lighten-1"
									class="text-none px-3"
									:value="2">
									Maestro
								</v-btn>
							</v-btn-toggle>
						</td>
					</tr>
					<tr>
						<th>Rapport de vérif</th>
						<td>
							<v-btn-toggle
								v-model="filters.has_rv"
								mandatory
								class="background darken-1 ma-1 darken-input">
								<v-btn
									small
									v-for="item in tristate_bool"
									:key="item.text"
									:color="item.color"
									:flat="filters.has_rv !== item.value"
									:class="{ 'color--text': filters.has_rv === item.value }"
									class="text-none px-3"
									:value="item.value">
									{{ item.text }}
								</v-btn>
							</v-btn-toggle>
						</td>
					</tr>
					<tr>
						<th>Proxy</th>
						<td>
							<v-btn-toggle
								v-model="filters.has_proxy"
								mandatory
								class="background darken-1 ma-1 darken-input">
								<v-btn
									small
									v-for="item in tristate_bool"
									:key="item.text"
									:color="item.color"
									:flat="filters.has_proxy !== item.value"
									:class="{ 'color--text': filters.has_proxy === item.value }"
									class="text-none px-3"
									:value="item.value">
									{{ item.text }}
								</v-btn>
							</v-btn-toggle>
						</td>
					</tr>
				</tbody>
			</table>
			<v-alert
				:value="nb_results === 10000 || uncomplete_query"
				color="warning"
				class="mt-3"
				icon="error_outline"
				outline>
				<span v-if="nb_results === 10000">
					Veuillez affiner votre recherche,
					la requête renvoie trop de résultats.
				</span>
				<span v-else-if="uncomplete_query">
					Veuillez affiner votre recherche, les critères sont incomplets.
					<br>
					(à minima Référence, Titre ou Recherche)
				</span>
			</v-alert>
		</v-card-text>
	</v-card>
</template>

<script>
import OwnerField from '@/components/field_owner.vue'
import BabelIdField from '@/components/field_babel_id_embedded.vue'
export default {
	props: [
		'loading',
		'nb_results',
		'uncomplete_query',
		'show_filters',
		'filters'
	],
	components: {
		OwnerField,
		BabelIdField
	},
	data () {
		return {
			ingest_date_after_menu: false,
			ingest_date_before_menu: false,
			asset_types: [
				{
					text: 'Video',
					icon: 'videocam',
					color: 'blue--text text--lighten-1'
				},
				{
					text: 'Sous-titre',
					icon: 'text_fields',
					color: 'green--text text--lighten-1'
				},
				{
					text: 'Audio',
					icon: 'volume_mute',
					color: 'deep-purple--text text--lighten-3'
				},
				{
					text: 'Package DCP',
					icon: 'theaters',
					color: 'indigo--text text--lighten-2'
				},
				{
					text: 'Package IMF',
					icon: 'movie',
					color: 'cyan--text'
				},
				{
					text: 'Sequence d\'image',
					icon: 'collections',
					color: 'teal--text text--lighten-2'
				},
				{
					text: 'Document',
					icon: 'description',
					color: 'amber--text'
				}
			],
			behive_categories: [
				{ text: 'hot', color: 'red--text', icon: 'whatshot' },
				{ text: 'catalog', color: 'info--text', icon: 'library_books' },
				{ text: 'cloud', color: 'teal--text', icon: 'cloud' },
				{ text: 'cold', color: 'primary--text', icon: 'ac_unit' },
				{ text: 'nearline', color: 'deep-purple--text text--lighten-2', icon: 'dns' },
				{ text: 'physical', color: 'amber--text', icon: 'voicemail' },
				{ text: 'data', color: 'white--text', icon: 'save' },
				{ text: 'ingesting', color: 'yellow--text', icon: 'input' },
				{ text: 'legacy', color: 'blue-grey--text text--lighten-2', icon: 'archive' }
			],
			tristate_bool: [
				{ text: 'Tous', value: 0, color: 'primary' },
				{ text: 'Oui', value: 1, color: 'success lighten-1' },
				{ text: 'Non', value: 2, color: 'error lighten-1' }
			]
		}
	},
	methods: {
		raz () {
			this.filters.search = null
			this.filters.ref_mat = null
			this.filters.t_aux = null
			this.filters.has_rv = false
			this.filters.asset_type_clean = null
			this.filters.babel_id = null
			this.filters.origin = 0
			this.filters.behive_category = null
			this.filters.has_proxy = 0
			this.filters.ingest_date_after = null
			this.filters.ingest_date_before = null
			this.search()
		},
		search () {
			this.$refs['babel-id-input'].$el.blur()
			this.$refs['search-input'].blur()
			this.$refs['ref-mat-input'].blur()
			this.$refs['behive-cat-input'].blur()
			this.$refs['taux-input'].$el.blur()
			this.$emit('search')
		},
		close (visible) {
			if (!visible) this.$emit('close')
		},
		OnkeyDown (evt) {
			if (evt.key === 'Escape') {
				if (!this.show_filters) return this.$emit('open')
				return this.$emit('close')
			}
			if (!this.show_filters) return
			if (evt.key === 'Enter' && evt.ctrlKey) {
				this.$nextTick(() => {
					this.search()
				})
			}
		}
	},
	mounted () {
		window.document.addEventListener('keydown', this.OnkeyDown, true)
		setTimeout(() => {
			let cardText = document.getElementById('card-text')
			let top = cardText.getBoundingClientRect().top
			cardText.style.minHeight = `calc(100vh - ${top}px)`
			cardText.style.maxHeight = `calc(100vh - ${top}px)`
			cardText.style.overflowY = 'auto'
		}, 100)
	},
	beforeDestroy () {
		window.document.removeEventListener('keydown', this.OnkeyDown, true)
	}
}
</script>

<style lang="stylus" scoped>
#filters
	width: 580px
	max-width: 580px
	min-width: 580px
	height: 100%
	background-color: var(--v-background-darken1) !important
	border-radius: 0
	border-right: 1px solid var(--v-background-lighten1) !important
	.v-card__title
		border-top: 1px solid var(--v-background-lighten1) !important
		border-bottom: 1px solid var(--v-background-lighten1) !important
	table
		width: 100%
		th
			font-weight: normal
			text-align: right
			width: 170px
		td
		th
			padding: 4px 8px

>>>.dense_input
	input
		top: 0 !important
	.v-input__control
		min-height: 32px !important
	.v-input__slot
		height: auto !important
		margin-top: 0 !important
		background-color: var(--v-background-base) !important
		border: 1px solid var(--v-background-lighten1) !important
	.v-chip--select-multi
		background-color: var(--v-background-darken1) !important

>>>.v-picker__body
	background: transparent !important
</style>



// WEBPACK FOOTER //
// src/pages/filesystem/title_asset_finder_filters.vue